import React from 'react';
import { QRData } from '../../types/qr';
import { HandleInputChangeFunction } from '../QRCodeGenerator';
import { Form, Label, Input, Select } from '../styled/FormElements';

interface WiFiQRFormProps {
  qrData: QRData;
  handleInputChange: HandleInputChangeFunction;
}

export const WiFiQRForm: React.FC<WiFiQRFormProps> = ({ qrData, handleInputChange }) => (
  <Form>
    <Label>
      Network Name (SSID):
      <Input
        type="text"
        name="ssid"
        value={qrData.wifi?.ssid || ''}
        onChange={(e) => handleInputChange(e, 'wifi')}
        placeholder="Enter network name"
        required
      />
    </Label>
    
    <Label>
      Password:
      <Input
        type="password"
        name="password"
        value={qrData.wifi?.password || ''}
        onChange={(e) => handleInputChange(e, 'wifi')}
        placeholder="Enter network password"
      />
    </Label>
    
    <Label>
      Security:
      <Select
        name="security"
        value={qrData.wifi?.security || 'WPA'}
        onChange={(e) => handleInputChange(e, 'wifi')}
      >
        <option value="WPA">WPA/WPA2</option>
        <option value="WEP">WEP</option>
        <option value="nopass">No Password</option>
      </Select>
    </Label>
  </Form>
); 